import React from 'react';
import { Box, Container, Grid, Typography, Link, IconButton } from '@mui/material';
import FacebookIcon from '@mui/icons-material/Facebook';
import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';
import LinkedInIcon from '@mui/icons-material/LinkedIn';

const Footer = () => {
  return (
    <Box
      component="footer"
      sx={{
        background: 'rgba(85, 37, 131, 0.06)',
        backdropFilter: 'blur(30px)',
        color: '#1a1a1a',
        py: 8,
        mt: 'auto',
        borderTop: '1px solid rgba(85, 37, 131, 0.15)',
        position: 'relative',
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* About */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom fontWeight={800} sx={{ letterSpacing: '0.1em', color: '#552583' }}>
              USAFIRI
            </Typography>
            <Typography variant="body2" sx={{ mb: 2, color: 'rgba(0,0,0,0.5)' }}>
              La livraison à Mayotte : restaurants et courses livrés chez vous.
            </Typography>
          </Grid>

          {/* Services */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom fontWeight={700} sx={{ letterSpacing: '0.05em', color: '#552583' }}>
              SERVICES
            </Typography>
            <Link href="/restaurants" color="text.secondary" display="block" sx={{ mb: 1, py: 0.5, textDecoration: 'none', '&:hover': { color: '#FDB927' } }}>
              Restauration
            </Link>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, py: 0.5 }}>
              <Typography variant="body2" sx={{ color: 'rgba(0,0,0,0.3)' }}>Covoiturage</Typography>
              <Box component="span" sx={{ bgcolor: 'rgba(85,37,131,0.1)', color: '#552583', fontSize: '0.6rem', fontWeight: 700, px: 0.7, py: 0.15, borderRadius: '4px' }}>BIENTÔT</Box>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, py: 0.5 }}>
              <Typography variant="body2" sx={{ color: 'rgba(0,0,0,0.3)' }}>Location Auto</Typography>
              <Box component="span" sx={{ bgcolor: 'rgba(85,37,131,0.1)', color: '#552583', fontSize: '0.6rem', fontWeight: 700, px: 0.7, py: 0.15, borderRadius: '4px' }}>BIENTÔT</Box>
            </Box>
            {['VTC', 'Logistique'].map((label) => (
              <Box key={label} sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1, py: 0.5 }}>
                <Typography variant="body2" sx={{ color: 'rgba(0,0,0,0.3)' }}>{label}</Typography>
                <Box component="span" sx={{ bgcolor: 'rgba(85,37,131,0.1)', color: '#552583', fontSize: '0.6rem', fontWeight: 700, px: 0.7, py: 0.15, borderRadius: '4px' }}>BIENTÔT</Box>
              </Box>
            ))}
          </Grid>

          {/* Support */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom fontWeight={700} sx={{ letterSpacing: '0.05em', color: '#552583' }}>
              SUPPORT
            </Typography>
            <Link href="/faq" color="text.secondary" display="block" sx={{ mb: 1, py: 0.5, textDecoration: 'none', '&:hover': { color: '#FDB927' } }}>
              Centre d'aide
            </Link>
            <Link href="/faq" color="text.secondary" display="block" sx={{ mb: 1, py: 0.5, textDecoration: 'none', '&:hover': { color: '#FDB927' } }}>
              FAQ
            </Link>
            <Link href="/partner/register" color="text.secondary" display="block" sx={{ mb: 1, py: 0.5, textDecoration: 'none', '&:hover': { color: '#FDB927' } }}>
              Devenir Partenaire
            </Link>
            <Link href="/politique-confidentialite" color="text.secondary" display="block" sx={{ mb: 1, py: 0.5, textDecoration: 'none', '&:hover': { color: '#FDB927' } }}>
              Politique de confidentialité
            </Link>
            <Link href="/cgu" color="text.secondary" display="block" sx={{ mb: 1, py: 0.5, textDecoration: 'none', '&:hover': { color: '#FDB927' } }}>
              CGU
            </Link>
            <Link href="/mentions-legales" color="text.secondary" display="block" sx={{ mb: 1, py: 0.5, textDecoration: 'none', '&:hover': { color: '#FDB927' } }}>
              Mentions légales
            </Link>
          </Grid>

          {/* Social */}
          <Grid item xs={12} sm={6} md={3}>
            <Typography variant="h6" gutterBottom fontWeight={700} sx={{ letterSpacing: '0.05em', color: '#552583' }}>
              SUIVEZ-NOUS
            </Typography>
            <Box>
              {[FacebookIcon, TwitterIcon, InstagramIcon, LinkedInIcon].map((Icon, i) => (
                <IconButton key={i} sx={{ color: 'rgba(85,37,131,0.5)', '&:hover': { color: '#FDB927' } }}>
                  <Icon />
                </IconButton>
              ))}
            </Box>
          </Grid>
        </Grid>

        <Box mt={6} pt={4} sx={{ borderTop: '1px solid rgba(85, 37, 131, 0.12)' }}>
          <Box sx={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', gap: { xs: 1, sm: 0.5 } }}>
            <Typography variant="body2" sx={{ color: 'rgba(0,0,0,0.4)', letterSpacing: '0.05em' }}>
              © {new Date().getFullYear()} USAFIRI. TOUS DROITS RÉSERVÉS.
            </Typography>
            <Box sx={{ display: 'flex', gap: { xs: 2, sm: 1 }, flexWrap: 'wrap', justifyContent: 'center' }}>
              {[
                { label: 'Confidentialité', href: '/politique-confidentialite' },
                { label: 'CGU', href: '/cgu' },
                { label: 'Mentions légales', href: '/mentions-legales' },
              ].map(({ label, href }) => (
                <Link key={href} href={href} sx={{
                  color: 'rgba(0,0,0,0.4)', textDecoration: 'none',
                  py: 0.5, px: 0.5, minHeight: 36,
                  display: 'inline-flex', alignItems: 'center',
                  '&:hover': { color: '#FDB927' },
                }}>
                  <Typography variant="body2">{label}</Typography>
                </Link>
              ))}
            </Box>
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
